import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { cfiNavigation, dealerNavigation, distributorNavigation, manufacturerNavigation, serviceProviderNavigation } from '../../app-navigation';
import { useAuth } from '../../contexts/auth';
import { useTitle } from '../../contexts/title';
import { CompanyTypes } from '../../types/enums';
import './Breadcrumbs.scss'

export default function Breadcrumbs() {
    const { title, dynamicLinks } = useTitle();
    const [params] = useSearchParams();
    let returnUrl = params.get("returnUrl");
    const { user } = useAuth();
    const location = useLocation();

    let locationPathName = location.pathname;
    if (locationPathName === '/menu') {
        const pageUrl = params.get("pageUrl");
        if (!!pageUrl) {
            locationPathName = pageUrl;
            let paramIndex = locationPathName.indexOf('?returnUrl');
            if (paramIndex > 0) {
                const pageParams = new URLSearchParams(locationPathName.substring(paramIndex));
                returnUrl = pageParams.get("returnUrl");
                locationPathName = locationPathName.substring(0, paramIndex);
            } else {
                returnUrl = null;
                paramIndex = locationPathName.indexOf('?');
                if (paramIndex > 0) {
                    locationPathName = locationPathName.substring(0, paramIndex);
                }
            }
        }
    }

    let breadcrumbs = [];

    let navigation = [] as any[];
    switch (user?.companyTypeId) {
        case CompanyTypes.CFI: {
            navigation = cfiNavigation;
            break;
        }
        case CompanyTypes.DEALER: {
            navigation = dealerNavigation;
            break;
        }
        case CompanyTypes.DISTRIBUTOR: {
            navigation = distributorNavigation;
            break;
        }
        case CompanyTypes.MFR: {
            navigation = manufacturerNavigation;
            break;
        }
        case CompanyTypes.SERVICE_PROVIDER: {
            navigation = serviceProviderNavigation;
            break;
        }
    }

    if (returnUrl) {
        for (const item of navigation) {
            for (const subItem of item.items) {
                if (subItem.path && returnUrl.includes(subItem.path)) {
                    breadcrumbs.push({ text: subItem.text, path: subItem.path });
                }

                if (subItem.items) {
                    for (const subSubItem of subItem.items) {
                        if (returnUrl.includes(subSubItem.path)) {
                            breadcrumbs = [];

                            let text = subSubItem.text;
                            if (returnUrl.includes("pastDue=true"))
                                text += " (Past Due Orders)";
                            if (returnUrl.includes("active=true"))
                                text += " (Active Orders)";
                            if (returnUrl.includes("pending=true"))
                                text += " (Pending Orders)";
                            breadcrumbs.push({ text: text, path: returnUrl });
                            break;
                        }
                    }
                }
            }
        }
    } else {
        for (const item of navigation) {
            for (const subItem of item.items) {
                if (subItem.path && locationPathName.includes(subItem.path) && locationPathName !== subItem.path) {
                    breadcrumbs.push({ text: subItem.text, path: subItem.path });
                }

                if (subItem.items) {
                    for (const subSubItem of subItem.items) {
                        if (locationPathName.includes(subSubItem.path) && locationPathName !== subSubItem.path) {
                            breadcrumbs.push({ text: subSubItem.text, path: locationPathName });
                            break;
                        }
                    }
                }
            }
        }
    }

    return (
        <div className='breadcrumbs'>
            {
                user?.companyTypeId !== CompanyTypes.EEPRO &&
                locationPathName !== '/home' &&
                <>
                    <Link to='/home'>Home</Link>
                    <span className="breadcrumb-separator">/</span>
                </>
            }
            {
                user?.companyTypeId !== CompanyTypes.EEPRO && dynamicLinks.length === 0 &&
                <>
                    {
                        breadcrumbs.map((item) => {
                            return (
                                <span key={item.path}>
                                    <Link to={item.path}>{item.text}</Link>
                                    <span className="breadcrumb-separator">/</span>
                                </span>
                            )
                        })
                    }
                </>
            }
            {
                dynamicLinks.length > 0 &&
                dynamicLinks.map((item) => {
                    return (<span key={item.path}>
                        <Link to={item.path}>{item.text}</Link>
                        <span className="breadcrumb-separator">/</span>
                    </span>)
                }
                )
            }
            <span>{title}</span>
        </div>
    );
}

